import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { modifiedBadgeTranslations } from '../../commons/utils/utils'

const initialState: Campaign = {
  CampaignID: null,
  CategoryName: '',
  Title: '',
  FeaturedUiPosition: null,
  IncludedCampaigns: '',
  translationLanguageList: [],
  status: '',
  StartTimestampUTC: '',
  IsDraft: false,
  EndTimestampUTC: '',
  Hidden: false,
  Disabled: false,
  CampaignType: '',
  RewardPerUser: '',
  customIconImageURL: null,
  headerImageURL: null,
  SubHeader: null,
  SubTitle: null,
  Name: '',
  Description: '',
  ExternalSurveyButtonLabel: null,
  ProviderSignupButtonLabel: null,
  SignupURL: null,
  TierType: null,
  tierBehaviorFilter: null,
  tierBehaviorSQLFilter: null,
  UiPosition: 0,
  campaignBadges: [],
  campaignLimit: null,
  PointExpiryDate: null,
  RepeatableBucketClaims: false,
  MaxBucketClaimsRepetition: null,
  MaxClaimsRepetition: null,
  transactionalAggregates: null,
  TotalReward: '',
  multiTripInfo: null,
  provider: [],
  transactionalFilter: null,
  specificDays: [],
  specificTimes: [],
  specificProductIDs: [],
  ActionType: '',
  RewardType: '',
  partner: [],
  SurveyFormID: '',
  campaignGeoInfo: [],
  campaignLevelInfo: [],
  validOffers: [],
  tierProperties: [],
  segmentationRulesForSurvey: [],
  ResultsNotes: '',
  GeneralNotes: '',
  ResultsNotesErr: '',
  GeneralNotesErr: '',
  categoryName: '',
  isFeaturedCampaign: false,
  CtaAction: '',
  NoSpendingExpiryInSeconds: null,
  HeaderImageID: null,
  CustomIconImageID: null,
  CampaignCategoryID: null,
  PartnerID: '',
  invoiceProvider: null,
  TenantID: null,
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    Title: null,
    SubTitle: null,
    SubHeader: null,
    Description: null,
    CTALabel: null
  },
  translations: {
    Title: null,
    SubTitle: null,
    SubHeader: null,
    Description: null,
    CTALabel: null,
    LanguageCode: null
  },
  defaultBadgeLabels: [],
  translatedBadgeLabels: [],
  earningConditions: [],
  LocationSnapShotID: null,
  locationSnapShotURL: null,
  HasParticipationLimit: false,
  ParticipationLimitQuantity: null,
  ParticipationLimitUnit: null,
  CreatedAtUTC: null,
  NoSpendingExpiryCampaignID: null,
  NoSpendingExpiryType: null,
  noSpendingExpiryCampaignTitle: null
}

export const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    setCampaignInfo: (state, action: PayloadAction<CampaignDetailsPayload>) => {
      return action.payload
    },
    setNotesValidationError: (
      state,
      action: PayloadAction<ValidateCampaignNotesParams>
    ) => {
      return {
        ...state,
        ResultsNotesErr: action.payload.ResultsNotes,
        GeneralNotesErr: action.payload.GeneralNotes
      }
    },
    setCampaignSelectedTranslations: (
      state,
      action: PayloadAction<SetCampaignTranslationParms>
    ) => {
      const modifiedBadgeTranslation = modifiedBadgeTranslations(
        action.payload.defaultBadgeLabels,
        action.payload.translatedBadgeLabels,
        action.payload.selectedLanguage
      )
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          Title: action.payload.translations?.Title ?? null,
          SubTitle: action.payload.translations?.SubTitle ?? null,
          SubHeader: action.payload.translations?.SubHeader ?? null,
          Description: action.payload.translations?.Description ?? null,
          CTALabel: action.payload.translations?.CTALabel ?? null,
          LanguageCode: action.payload.selectedLanguage
        },
        defaultBadgeLabels: action.payload.defaultBadgeLabels,
        translatedBadgeLabels: modifiedBadgeTranslation
      }
    }
  }
})

export const {
  setCampaignInfo,
  setNotesValidationError,
  setCampaignSelectedTranslations
} = campaignSlice.actions
export const campaignReducer = campaignSlice.reducer
